import { filtersToQueryString } from "utils/requests";

import type { ItfSearchTaxRetentions, TypesToDownloadRetentionFile } from "types/taxes";

/*-------------------
------- CATALOGS ------
---------------------*/

export const endpointCatalogs = (): string => {
  return "/catalogs";
};

export const endpointStatesOfCountry = (params?: { id?: number | string }): string => {
  const { id = 1 } = params || {};
  return `${endpointCatalogs()}/countries/${id}/states`;
};

/*-------------------
------- HERU USERS ------
---------------------*/

export const endpointLogin = (): string => "/users/login";

/*-------------------
------- TAXPAYERS ------
---------------------*/

export const endpointTaxpayers = (params?: { filters?: any }): string => {
  const { filters = {} } = params;
  return "b2b/v2/b2b/certifications_by_filters_partnerid" + filtersToQueryString(filters);
};

export const endpointTaxpayer = (params?: { taxpayerId?: number | string }): string => {
  const { taxpayerId = 0 } = params;
  return `/certification/user/${taxpayerId}`;
};

export const endpointCreateTaxpayer = (): string => "/fiscal/operations/taxpayers";

export const endpointUpdateTaxpayer = (params: { taxpayerId: number }): string => {
  const { taxpayerId } = params;
  return `/fiscal/operations/taxpayers/${taxpayerId}`;
};

/*-----------------------------------
------- RETENTIONS and ISSUANCE ------
-------------------------------------*/
export const endpointGetTaxRetentions = ({ filters }: { filters: ItfSearchTaxRetentions }): string => {
  return "b2b/v2/b2b/certifications_by_filters_partnerid" + filtersToQueryString(filters);
};

export const endpointCancelRetention = (params: { docId: number }): string => {
  const { docId } = params;
  return `/fiscal/operations/tax-retentions/cancel/${docId}`;
};

export const endpointCreateFiscalDoc = (params: { taxpayerId: number }): string => {
  const { taxpayerId } = params;
  return `/fiscal/operations/taxpayers/${taxpayerId}/issuances`;
};

export const endpointGetTaxRetentionFile = (params?: {
  docId: number;
  type?: TypesToDownloadRetentionFile;
}): string => {
  const { docId, type = "pdf" } = params;
  return `/fiscal/operations/tax-retentions/${docId}/download/${type}`;
};
